import clsx from 'clsx';

export const Panel = ({ category = 'default', height = 'full', width = 'full', rounded= false, overflowAuto= true, title, children, className, noPadding, subTitle, noHeader }) => {
  const getBackgroundColor = () => {
    if (category === 'default') {
      return 'bg-perception-black-800';
    } else if (category === 'main') {
      return 'bg-perception-black-900';
    } else if (category === 'secondary') {
      return 'bg-perception-black-500';
    }
  };

  const getHeight = () => height === 'full' ? 'h-full' : height;
  const getWidth = () => width === 'full' ? 'w-full' : width;

  const getRounded = () => rounded ? 'rounded-md' : '';
  const getOverflowAuto = () => overflowAuto ? 'overflow-y-auto' : '';

  return (
    <div className={clsx('panel', getBackgroundColor(), getHeight(), getWidth(), getRounded(), 'overflow-hidden flex flex-col relative', className)}>
      {!noHeader && <HeaderPanel title={title} subTitle={subTitle} />}
      <div className={clsx(noPadding ? '' : 'py-4 px-4', 'flex-1 min-h-0 w-full flex flex-col text-perception-gray-500', getOverflowAuto())}>{children}</div>
    </div>
  );
};

const HeaderPanel = ({ title, subTitle }) => {
  return (
    <div className='bg-perception-gray-800 flex justify-between px-4 py-[0.15rem] w-full'>
      <span className='text-white text-xs'>{title}</span>
      {
        subTitle && <span className='text-white text-xs'>{subTitle}</span>
      }
    </div>
  );
};
